module.exports = __webpack_public_path__ + "img/cancle.9c886d06.svg";